<template>
  <CustomTimeLine :items="items" />
</template>

<script>
import moment from 'moment';
import CustomTimeLine from 'custom-time-line';
import { getCardHistory as _getCardHistory } from '@/modules/shared/cardHandling.api.js';
import { getCardStatusColor } from '@/utils/constants/cardStatusses.js';

export default {
  name: 'History',
  components: {
    CustomTimeLine,
  },
  props: {
    card: {
      type: Object,
      required: true,
      default() {
        return {
          id: 0,
        };
      },
    },
  },
  data: () => ({
    items: [],
  }),
  async mounted() {
    const { data } = await _getCardHistory(this.card.id);
    this.items = data.map((item) => ({
      status: {
        text: item.newStatus,
        color: getCardStatusColor(item.newStatusId, true),
      },
      date: moment(item.createdDate).format('DD/MMM/YYYY'),
      text: `Creado por:\r\n${item.createdBy}`,
    }));
  },
};
</script>
